import {useQuery} from "@tanstack/react-query";
import {readStndApi} from "../../../../api/support/RMA";

interface ReadStndProps {
    keyword?: string;
    limit?: number;
    pageNo?: number;
}

export default function useReadStnd({keyword='', limit=10, pageNo=1}: ReadStndProps) {
    return useQuery({
        queryKey: ['readStnd', {keyword, limit, pageNo}],
        queryFn: async () => {
            const response = await readStndApi({keyword, limit, pageNo});
            return response.result;
        }
    })
}